import axios from 'axios';
import { BACKOFFICE_DEPLOYMENT, BACKOFFICE_LOCALHOST } from './servers';

const instance = axios.create({
  baseURL: BACKOFFICE_DEPLOYMENT,
});

export default instance;
